import validation from "./validation";
import customSelect from "./customSelect";

const changeAddress = () => {
    function createAddressForm(way) {
        const newAddress = document.createElement('form');
        newAddress.setAttribute('class', 'delivery-item delivery-item__edit');
        way.appendChild(newAddress);
        const titleBlock = document.createElement('div');
        titleBlock.setAttribute('class', 'flex');
        newAddress.appendChild(titleBlock);
        const titleInput = document.createElement('input');
        titleInput.setAttribute('class', 'input input_short name-input');
        titleInput.setAttribute('placeholder', 'Address name');
        titleBlock.appendChild(titleInput);

        const links = document.createElement('div');
        links.setAttribute('class', 'delivery-item__links');
        titleBlock.appendChild(links);
        
        const editLink = document.createElement('a');
        editLink.setAttribute('class', 'delivery-edit');
        editLink.setAttribute('href', '#');
        links.appendChild(editLink);
        const editImg = document.createElement('img');
        editImg.setAttribute('src', '../icons/products/edit.svg');
        editLink.appendChild(editImg);
        editLink.style.display = 'none';
        const removeLink = document.createElement('a');
        removeLink.setAttribute('class', 'delivery-remove');
        removeLink.setAttribute('href', '#');
        links.appendChild(removeLink);
        const removeImg = document.createElement('img');
        removeImg.setAttribute('src', '../icons/products/bucket.svg');
        removeLink.appendChild(removeImg);
        



        const flex = document.createElement('div');
        flex.setAttribute('class', 'flex');
        newAddress.appendChild(flex);
        const flexBlock = document.createElement('div');

        function createSelect(selectorSelect, arr, className, labelText) {
            const div = document.createElement('div');
            const flexBlock = document.createElement('div');
            const label = document.createElement('label');
            label.innerText = labelText;
            flexBlock.setAttribute('class', "flex-block");
            div.setAttribute('class', "custom-select input");
            selectorSelect.setAttribute('class', className);
            
            flex.appendChild(flexBlock);
            flexBlock.appendChild(label);
            flexBlock.appendChild(div);
            div.appendChild(selectorSelect)

            
            for(let i = 0; i < arr.length; i++) {
                let option = document.createElement('option');
                option.setAttribute('value', i);
                selectorSelect.appendChild(option);
                option.innerHTML = arr[i];
            }
            
        }


        let arr = ['Country', 'Canada', 'USA', 'China'];
        const input = document.createElement('input'),
            label = document.createElement('label'),
            countrySelect = document.createElement('select'),
            postalSelect = document.createElement('select'),
            stateSelect = document.createElement('select'),
            citySelect = document.createElement('select'),
            saveBtn = document.createElement('button');
        saveBtn.setAttribute('class', 'btn');
        saveBtn.innerHTML = 'Save';
                    


        input.setAttribute('class', 'input address-input');
        flex.appendChild(flexBlock);

        flexBlock.appendChild(label);
        label.textContent = 'Address Line';
        flexBlock.setAttribute('class', "flex-block");
        flexBlock.appendChild(input);
        createSelect(countrySelect, arr, 'country-input', 'Country');
        createSelect(stateSelect, arr, 'state-input', 'State');
        createSelect(citySelect, arr, 'city-input', 'City');
        createSelect(postalSelect, arr, 'postal-input', 'Postal/Zip');
        flex.appendChild(saveBtn);
        customSelect();
        validation();

        // fetch data 
        // newAddress.addEventListener('submit', () => {
        //     if(noErrors) {
        //         submitAddress()
        //     }
            
        // })
    }
    // function submitAddress() {
    //     const addressName = document.createElement('div');
    //     addressName.setAttribute('class', 'delivery-item__title');
    //     addressName.innerHTML = titleInput.value;
    //     titleInput.insertAdjacentElement('beforebegin', addressName);
    //     titleInput.remove();
    //     const addressLine = document.createElement('div');
    //     addressLine.setAttribute('class', 'delivery-item__descr');
    //     addressLine.innerHTML = `${input.value}, ${countrySelect.options[countrySelect.selectedIndex].text}, ${stateSelect.options[stateSelect.selectedIndex].text}, ${citySelect.options[citySelect.selectedIndex].text}, ${postalSelect.options[postalSelect.selectedIndex].text}`;
    //     flex.insertAdjacentElement('beforebegin', addressLine);
    //     editLink.style.display = 'inline'
    //     flex.remove();
    //     var editBtn = document.querySelectorAll('.delivery-edit');
    //     editAddressForm (editBtn);
    //     addBtn.style.display = 'block';
    // }
    var editBtn = document.querySelectorAll('.delivery-edit'),
          addBtn = document.querySelector('.delivery__add');
    if(addBtn) {
        addBtn.addEventListener('click', (e) => {
            e.preventDefault();
            let way = addBtn.previousElementSibling;
            createAddressForm(way);
            addBtn.style.display = 'none';
        })
    }
    if(editBtn) {
        editAddressForm (editBtn);
    }

    function editAddressForm (editBtn) {
        editBtn.forEach(item => {
            item.addEventListener('click', (e) => {
                e.preventDefault();
                let way = item.parentElement.parentElement.parentElement.parentElement;
                createAddressForm(way);
                item.parentElement.parentElement.parentElement.remove();


            })
        })
    }
}

export default changeAddress;